export const PATH_EQUIVALENCES_STATE_GLOBAL_STATE_KEY = "path-equivalences-state"
export const UPDATE_PATH_EQUIVALENCES_STATE_ACTION = "update-path-equivalences-state-action"